import { AppDefinition } from '../../types/apps';

export const SocialStudioAppDefinition: AppDefinition = {
  appId: 'socialstudio',
  name: 'Social Studio',
  version: '1.0.0',
  description:
    'Draft and compose social media posts for LinkedIn, Twitter, and more. ' +
    'Posts are rendered exactly as they will appear on-platform, with AI-assisted drafting and image generation.',

  icon: {
    type: 'phosphor',
    phosphorIcon: 'ShareNetwork',
    phosphorWeight: 'duotone',
    color: '#0077b5',
    metadata: { source: 'app', appId: 'socialstudio', isAppIcon: true },
  },

  entityIcons: {
    SocialPost: {
      type: 'phosphor',
      phosphorIcon: 'ShareNetwork',
      phosphorWeight: 'duotone',
      color: '#0077b5',
    },
  },

  entityTypes: ['SocialPost'],

  searchableSkeletonFields: {
    SocialPost: ['title', 'channel', 'postType'],
  },

  component: 'SocialStudioApp',
  requiresProps: false,
  requiresEntity: false,

  agenticToolIds: ['social_post_create'],
  features: [],
  actions: {},
};
